import type * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import { useSettings } from "~mangomap-ui/components/core/settings/settings-context";
import { createTheme } from "~mangomap-ui/styles/theme/create-theme";

export interface ThemeProviderProps {
	children: React.ReactNode;
}

function CustomThemeProvider({
	children,
}: ThemeProviderProps): React.JSX.Element {
	const { settings } = useSettings();

	const direction = settings.direction;
	const primaryColor = settings.primaryColor;

	const theme = createTheme({ direction, primaryColor });

	return (
		<ThemeProvider
			disableTransitionOnChange
			theme={theme}
			defaultMode="light">
			<CssBaseline />
			{children}
		</ThemeProvider>
	);
}

export { CustomThemeProvider as ThemeProvider };
